import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
const styles = xcss({
  width: '360px'
});
export const AgentProfileCardWrapper = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles
  }, children);
};